<template>
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">

      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">

          <div class="login">

            <div class="logo">
              <img src="./../assets/img/logo-login.png" alt="Arrow Logistics" />
            </div>

            <form method="post" @submit.prevent="login">
              <div class="form-group-outer">
                <div class="form-group float-label-control form-group-email" >
                  <label for="">Email/Mobile</label>
                  <input type="email" class="form-control" placeholder="Email/Mobile" v-model="email" v-float-label/>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control form-group-password" >
                  <label for="">Password</label>
                  <input type="password" class="form-control" placeholder="Password" v-model="password" v-float-label/>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <router-link :to="{ name: 'submit-load' }" class="btn btn-xs btn-primary">Submit Load Details</router-link>
                </div>
                <div class="col-xs-6 text-right">
                  <ladda-button button-type="submit" class="pull-right" type="success" size="large" :on-click="handleLogin">Login</ladda-button>
                </div>
              </div>
            </form>

            <div class="login-footer">
              <div class="row">
                <div class="col-xs-7">
                  <router-link :to="{ name: 'auth.forgot' }">Forgot Password?</router-link>
                </div>
                <div class="col-xs-5 text-right">
                  <router-link :to="{ name: 'auth.register' }">Register</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { auth, notify } from 'utils'
  import LaddaButton from 'components/forms/LaddaButton'
  import $ from 'jquery'

  export default {
    components: {
      LaddaButton
    },

    data () {
      return {
        email: '',
        password: '',
        error: null
      }
    },

    mounted () {
      $('body').addClass('pace-top')
    },

    created () {
      if (this.$echo) {
        this.$echo.disconnect()
      }
    },

    watch: {
      /**
      * Watch the error and notify when it changes.
      *
      * @param string error
      *
      * @return void
      */
      error (error) {
        if (error) {
          notify.error(error)
        }
      }
    },

    methods: {
      handleLogin () {
        this.error = null

        return auth.attempt(this.email, this.password).then(response => {
          if (response.data.user.valid) {
            if (response.data.user.email_verified) {
              // If we have a redirect in the query string then we'll send the user back to
              // where they were kicked out from.
              if (this.$router.currentRoute.query.redirect) {
                this.$router.push({ path: this.$router.currentRoute.query.redirect })

              // Otherwise they can just go straight to the dashboard.
              } else {
                this.$router.push({ name: 'dashboard' })
              }

            // If the users e-mail is not verified yet we'll take them to the authentication
            // success page so they can see the message telling them to verify or resend
            // the verification e-mail.
            } else {
              this.$router.push({ name: 'auth.success' })
            }

          // If the user is not yet valid then they need to enter some more details so we'll
          // redirect them to the auth details route.
          } else {
            this.$router.push({ name: 'auth.details' })
          }
        }).catch(error => {
          if (error.response) {
            if (error.response.status === 401) {
              if (error.response.data.error === 'invalid_credentials') {
                this.error = 'The credentials you provided were invalid.'
              } else if (error.response.data.error === 'child_account_disabled') {
                this.error = 'Your account has been disabled.'
              } else if (error.response.data.error === 'driver_login_not_allowed') {
                this.error = 'Sorry drivers are not able to use the web portal.'
              }
            } else if (error.response.status === 500) {
              this.error = 'There was a problem authenticating with the server.'
            }
          } else {
            this.error = error.message
          }
        })
      }
    }
  }
</script>

<style>
  .float-label-control label {
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?1ac3f815